import { TCustomCell } from "components/Category/Category";
import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import ReactDOM from "react-dom";
import { Modal } from "components/modal/Modal";
import Entity from "components/Entity";
import { endpoints } from "config";
import {
  documentsOverrideFormReadOnlyFieldRenderer,
  documentsReadOnlyRightsRenderer,
  documentsRightsRenderer,
} from "pages/Documents/Document";

type Props<T> = {
  customRowCells: { [k in keyof T]?: TCustomCell<T> | undefined };
  row: { [K in keyof T]: React.ReactNode };
  k: string;
  id: string;
  setCustomCellValue?: React.Dispatch<any>;
  customCellValue?: any;
  refs?: { selectRef?: any; containerRef?: any };
  parentSelectedId?: number;
};
export const ViewDocumentCell = <T extends { [K: string]: React.ReactNode }>(
  props: Props<T>
) => {
  const {
    row,
    customRowCells,
    k,
    id,
    customCellValue,
    setCustomCellValue,
    refs,
    parentSelectedId,
  } = props;

  const cellValue = customCellValue?.find(
    (r: any) => r.id.toString() === id.toString()
  ) as any;

  const finalValue =
    typeof cellValue === "object" && cellValue.hasOwnProperty(k)
      ? cellValue[k]
      : null;

  const [showViewDocumentPopUp, setShowViewDocumentPopUp] = useState<boolean>(
    false
  );

  return (
    <>
      <div className="ViewDocumentCell">
        <div
          className={`Btn ${typeof finalValue === "number" ? "" : "Disabled"}`}
          onClick={e => {
            e.stopPropagation();

            setShowViewDocumentPopUp(true);
          }}
        >
          View
        </div>
      </div>

      {showViewDocumentPopUp && (
        <Modal
          open={showViewDocumentPopUp}
          closeModal={() => setShowViewDocumentPopUp(false)}
          title={`View Document`}
        >
          <ViewDocumentPopUp
            id={finalValue}
            onDone={() => setShowViewDocumentPopUp(false)}
          />
        </Modal>
      )}
    </>
  );
};

type ViewDocumentPopUpProps = {
  id: number;
  onDone: () => void;
};

export const ViewDocumentPopUp: React.FC<ViewDocumentPopUpProps> = ({
  id,
  onDone,
}) => {
  return (
    <>
      <Entity
        initialDataUrl={endpoints.documents.view}
        readOnly={true}
        submitUrl={endpoints.documents.view}
        onDone={onDone}
        selectedData={[{ documents__Id: id }]}
        idFromRowOption={id}
        hiddenFields={undefined}
        readOnlyFields={undefined}
        formType="multipart"
        fieldRenderers={documentsRightsRenderer}
        validationSchema={undefined}
        readOnlyFieldRenderers={documentsReadOnlyRightsRenderer}
        overrideFormReadOnlyFieldRenderer={
          documentsOverrideFormReadOnlyFieldRenderer
        }
        nullStringValues={[]}
        fetchConfig={{
          params: {
            Id: id,
          },
        }}
        groupColumns={undefined}
        conditionalFields={{
          // When "Other user" is ticked, the companies multi-select should appear (and is mandatory), and it doesn't appear when "Principle user" is ticked
          ProgrammesIDs: {
            dependentField: "DocumentLevelsID",

            dependentValues: ["programme"], // must be lowercase
            useLabelInsteadOfId: true,
            datasourceField: "listDocumentLevels",
          },
          SitesIDs: {
            dependentField: "DocumentLevelsID",

            dependentValues: ["site"],
            useLabelInsteadOfId: true,
            datasourceField: "listDocumentLevels",
          },

          Programmes: {
            dependentField: "DocumentLevelsName",
            dependentValues: ["Programme"],
          },
          Sites: {
            dependentField: "DocumentLevelsName",
            dependentValues: ["Site"],
          },
          Projects: {
            dependentField: "DocumentLevelsName",
            dependentValues: ["Project"],
          },
        }}
        hideGroupLabel
      />
    </>
  );
};
